/* VB · cabecera: sólida al hacer scroll (portada transparente), mega menú (hover/foco/clic, Esc),
   menú móvil a pantalla completa con foco atrapado y bloqueo de scroll real (iOS incluido).
   Capas excluyentes por el evento «vb:overlay» (carrito, buscador, menú). */
if (!customElements.get('vb-header')) {
  customElements.define('vb-header', class extends HTMLElement {
    connectedCallback() {
      this.wrap = this.closest('.shopify-section') || this;
      this.transparent = this.classList.contains('vb-header--transparent');
      this.drawer = this.querySelector('.vb-drawer');
      this.burger = this.querySelector('[data-vb-drawer-open]');
      this.mega = this.querySelector('[data-vb-mega]');
      this.trigger = this.querySelector('[data-vb-mega-trigger]');

      this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); }); };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      const bar = this.querySelector('.vb-header__bar');
      this.ro = new ResizeObserver(() => { if (bar?.offsetHeight) document.documentElement.style.setProperty('--header-h', `${bar.offsetHeight}px`); });
      if (bar) this.ro.observe(bar);

      // Mega menú: se abre al pasar por el disparador o por el panel; se cierra al salir de ambos (con margen)
      if (this.mega && this.trigger) {
        const item = this.trigger.closest('.vb-header__item');
        const enter = () => { clearTimeout(this.megaT); this.openMega(); };
        const leave = () => { clearTimeout(this.megaT); this.megaT = setTimeout(() => this.closeMega(), 160); };
        [item, this.mega].forEach((el) => { el.addEventListener('mouseenter', enter); el.addEventListener('mouseleave', leave); });
        this.trigger.addEventListener('focus', enter);
        this.trigger.addEventListener('click', (e) => {
          if (window.matchMedia('(hover: hover)').matches) return; // con ratón el enlace navega
          if (!this.classList.contains('is-mega-open')) { e.preventDefault(); this.openMega(); }
        });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.closeMega(); });
        this.querySelector('[data-vb-mega-veil]')?.addEventListener('click', () => this.closeMega());
      }

      this.burger?.addEventListener('click', () => this.openDrawer());
      this.querySelectorAll('[data-vb-drawer-close]').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
      this.drawer?.addEventListener('click', (e) => { if (e.target.closest('a[href]') && !e.target.closest('[data-vb-cart-open]')) this.closeDrawer(true); });
      this.onKey = (e) => {
        if (e.key === 'Tab' && this.drawer?.classList.contains('is-open')) return this.trap(e);
        if (e.key !== 'Escape') return;
        if (this.drawer?.classList.contains('is-open')) this.closeDrawer();
        else if (this.classList.contains('is-mega-open')) { this.closeMega(); this.trigger?.focus(); }
      };
      document.addEventListener('keydown', this.onKey);
      this.onOverlay = (e) => { if (e.detail !== 'menu') { this.closeDrawer(true); this.closeMega(); } };
      document.addEventListener('vb:overlay', this.onOverlay);
      this.lockWatch();
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('vb:overlay', this.onOverlay);
      this.ro?.disconnect();
      this.mo?.disconnect();
      document.body.classList.remove('vb-lock');
    }

    update() {
      let top = 0; // alto de lo que va encima (barra de anuncios)
      for (let el = this.wrap.previousElementSibling; el; el = el.previousElementSibling) if (el.classList.contains('shopify-section')) top += el.offsetHeight || 0;
      const scrolled = window.scrollY > top + 2;
      this.classList.toggle('is-scrolled', scrolled);
      if (this.transparent) this.classList.toggle('is-solid', scrolled || this.classList.contains('is-mega-open') || !!this.drawer?.classList.contains('is-open'));
    }

    openMega() {
      if (!this.mega || this.classList.contains('is-mega-open')) return;
      document.dispatchEvent(new CustomEvent('vb:overlay', { detail: 'menu' }));
      this.classList.add('is-mega-open');
      this.trigger?.setAttribute('aria-expanded', 'true');
      this.update();
    }

    closeMega() {
      if (!this.classList.contains('is-mega-open')) return;
      this.classList.remove('is-mega-open');
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.update();
    }

    /* Bloqueo de scroll con menú o carrito abiertos: en táctil se fija el body y al cerrar se devuelve la posición */
    lockWatch() {
      const body = document.body;
      const apply = () => {
        const touch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
        const full = touch && body.classList.contains('vb-lock') && document.querySelector('.vb-drawer.is-open, [data-vb-cart-drawer].is-open');
        if (full && !this.lockedY) {
          this.lockedY = window.scrollY || 1;
          Object.assign(body.style, { position: 'fixed', top: `-${window.scrollY}px`, left: '0', right: '0', width: '100%' });
        } else if (!full && this.lockedY) {
          const y = this.lockedY === 1 ? 0 : this.lockedY;
          this.lockedY = 0;
          Object.assign(body.style, { position: '', top: '', left: '', right: '', width: '' });
          const html = document.documentElement, sb = html.style.scrollBehavior;
          html.style.scrollBehavior = 'auto';
          window.scrollTo(0, y);
          html.style.scrollBehavior = sb;
        }
      };
      this.mo = new MutationObserver(() => requestAnimationFrame(apply));
      this.mo.observe(body, { attributes: true, attributeFilter: ['class'] });
    }

    trap(e) {
      const f = [...this.drawer.querySelectorAll('a[href], button:not([disabled]), summary')].filter((n) => n.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (!this.drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    openDrawer() {
      if (!this.drawer) return;
      document.dispatchEvent(new CustomEvent('vb:overlay', { detail: 'menu' }));
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.burger?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('vb-lock');
      // Cada vez que se abre el menú, «Productos» vuelve a su estado por defecto (cerrado)
      this.drawer.querySelectorAll('details.vb-drawer__acc:not([data-open-default])').forEach((d) => { d.open = false; });
      setTimeout(() => this.drawer.querySelector('[data-vb-drawer-close]')?.focus({ preventScroll: true }), 60);
      this.update();
    }

    closeDrawer(silent) {
      if (!this.drawer?.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.burger?.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-vb-cart-drawer].is-open')) document.body.classList.remove('vb-lock');
      if (!silent) this.burger?.focus({ preventScroll: true });
      this.update();
    }
  });
}

/* Favoritos: contador del corazón (IDs en localStorage «vb:favs»). Se actualiza con «vb:favs:changed», «storage» y al volver atrás. */
if (!window.__vbFavCount) {
  window.__vbFavCount = true;
  const favCount = () => {
    let n = 0;
    try { const v = JSON.parse(localStorage.getItem('vb:favs') || '[]'); n = Array.isArray(v) ? new Set(v.map(String)).size : 0; } catch (_) {}
    document.querySelectorAll('[data-vb-fav-count]').forEach((el) => { el.textContent = n > 99 ? '99+' : String(n); el.hidden = n === 0; });
  };
  document.addEventListener('vb:favs:changed', favCount);
  window.addEventListener('storage', (e) => { if (e.key === 'vb:favs' || e.key === null) favCount(); });
  window.addEventListener('pageshow', favCount);
  document.addEventListener('shopify:section:load', favCount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', favCount); else favCount();
}
